import React from 'react';
import Table, { TableRow, TableHeading, TableBody, TableCell } from '../../table/Table';
import starlingBankLogo from '../../../../content/media-library/logos/starling-bank-logo-horizontal.svg';
import industryIcon from '../../../../content/media-library/icons/icon-industry.svg';

const Summaries = ({ dataset }) => (
  <Table theme="neutralNavy">
    <TableHeading>
      <TableCell as="th" fill></TableCell>
      <TableCell as="th" fill>
        Service Availability (%)
      </TableCell>
      <TableCell as="th" fill>
        Average Response (ms)
      </TableCell>
      <TableCell as="th" fill>
        Error rate (% failed calls)
      </TableCell>
      <TableCell as="th" fill>
        Successful API calls (%)
      </TableCell>
    </TableHeading>
    <TableBody>
      <TableRow>
        <TableCell fill strong as="th">
          <img src={starlingBankLogo} alt="Starling Bank Logo" />
        </TableCell>
        <TableCell textSize="lg" strong>
          {dataset.mobile.availability}
        </TableCell>
        <TableCell textSize="lg" strong>
          {dataset.mobile.responseTime}
        </TableCell>
        <TableCell textSize="lg" strong>
          {dataset.mobile.errorRate}
        </TableCell>
        <TableCell textSize="lg" strong>
          {dataset.mobile.successfulApiCallsPct}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell fill strong textSize="md" as="th">
          <img src={industryIcon} alt="Industry icon" />
          <span>Industry-wide</span>
        </TableCell>
        <TableCell textSize="lg" strong>
          {dataset.partner.availability}
        </TableCell>
        <TableCell textSize="lg" strong>
          {dataset.partner.responseTime}
        </TableCell>
        <TableCell textSize="lg" strong>
          {dataset.partner.errorRate}
        </TableCell>
        <TableCell textSize="lg" strong>
          {dataset.partner.successfulApiCallsPct}
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
);

export default Summaries;
